import { useState } from "react";
import { Modal, Form, Input, Button } from "antd";
import {
  renderErrorNotifications,
  renderSuccessNotifications,
} from "helpers/error.helpers";
import { sendMemberOtp, addMember } from "../team.service";

function AddMemberModal({ open, onClose, onAdded }) {
  const [form] = Form.useForm();
  const [otpSent, setOtpSent] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [adding, setAdding] = useState(false);

  const reset = () => {
    form.resetFields();
    setOtpSent(false);
    setSendingOtp(false);
    setAdding(false);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSendOtp = async () => {
    const values = await form.validateFields(["name", "phone_number"]);
    setSendingOtp(true);
    const { errors } = await sendMemberOtp(values.phone_number);
    setSendingOtp(false);
    if (errors?.length > 0) {
      renderErrorNotifications(errors);
      return;
    }
    setOtpSent(true);
    renderSuccessNotifications({
      title: "OTP sent",
      message: `Ask ${values.name} for the 6-digit code sent to their phone.`,
    });
  };

  const handleAdd = async () => {
    const values = await form.validateFields();
    setAdding(true);
    const { errors } = await addMember(values);
    setAdding(false);
    if (errors?.length > 0) {
      renderErrorNotifications(errors);
      return;
    }
    renderSuccessNotifications({
      title: "Member added",
      message: `${values.name} can now manage this account.`,
    });
    reset();
    onAdded();
  };

  return (
    <Modal
      title="Add a member"
      open={open}
      onCancel={handleClose}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" className="pt-2">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Enter the person's name." }]}
        >
          <Input placeholder="e.g. Priya Sharma" disabled={otpSent} />
        </Form.Item>
        <Form.Item
          name="phone_number"
          label="Phone number"
          rules={[
            {
              pattern: /^\d{10}$/,
              message: "Enter a valid 10-digit phone number.",
            },
            { required: true, message: "Enter a phone number." },
          ]}
        >
          <Input
            type="tel"
            inputMode="numeric"
            placeholder="9876543210"
            maxLength={10}
            disabled={otpSent}
          />
        </Form.Item>

        {otpSent && (
          <Form.Item
            name="otp"
            label="OTP"
            normalize={(value) => value?.replace(/\D/g, "")}
            rules={[
              { required: true, message: "Enter the OTP they received." },
              { pattern: /^\d{6}$/, message: "OTP should be 6 digits." },
            ]}
          >
            <Input maxLength={6} inputMode="numeric" placeholder="123456" />
          </Form.Item>
        )}

        <div className="flex items-center justify-end gap-2 pt-2">
          <Button onClick={handleClose}>Cancel</Button>
          {otpSent ? (
            <Button type="primary" loading={adding} onClick={handleAdd}>
              Add member
            </Button>
          ) : (
            <Button type="primary" loading={sendingOtp} onClick={handleSendOtp}>
              Send OTP
            </Button>
          )}
        </div>
      </Form>
    </Modal>
  );
}

export default AddMemberModal;
